export function LoginComponent() {

    return <div style={{ display: "grid", placeContent: "center", placeItems: "center", height: "100vh" }}>
        <h1>Login</h1>
        <form style={{ display: "contents" }} onSubmit={async e => {
            e.preventDefault();
            const pw = e.currentTarget.querySelector<HTMLInputElement>("input[type=password]")?.value;
            if (!pw) return;
            const response = await fetch("/api/auth/login", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(pw)
            });
            if (!response.ok) {
                window.alert(`Login fehlgeschlagen: ${response.status} ${response.statusText}\n\n` + (await response.text()));
                return;
            }
            localStorage.setItem("token", (await response.json()).token);
            window.location.href = "/#/";
        }}>
            <p>
                Passwort: <input type="password" />
            </p>
            <button type="submit">
                Login
            </button>
        </form>
    </div>;
}
